// Device-trust token persistence.
//
// After a user verifies a new device, the backend returns a long-lived trust
// token which we store in localStorage. It is sent back on subsequent logins
// so the device is recognised and the extra email verification is skipped.
// localStorage (not a cookie) is used deliberately: the frontend and backend
// are on different origins in production, so a cookie would be treated as
// third-party and blocked in some browsers. The frontend reads this value and
// sends it explicitly in the request body instead.

const DEVICE_TOKEN_KEY = 'pm_device_token';

export const getDeviceToken = (): string => {
  try {
    return localStorage.getItem(DEVICE_TOKEN_KEY) || '';
  } catch {
    return '';
  }
};

export const setDeviceToken = (token: string): void => {
  try {
    if (token) {
      localStorage.setItem(DEVICE_TOKEN_KEY, token);
    }
  } catch {
    /* localStorage unavailable (private mode quota, etc.) — ignore */
  }
};

export const clearDeviceToken = (): void => {
  try {
    localStorage.removeItem(DEVICE_TOKEN_KEY);
  } catch {
    /* ignore */
  }
};
